export default {
  reset_password_title: "Passwort zurücksetzen",
  invalid_reset_token: "Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen",
  invalid_reset_token_desc:
    "Der von Ihnen angegebene Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link zum Zurücksetzen des Passworts an.",
  password_reset_success: "Ihr Passwort wurde erfolgreich zurückgesetzt",
  password_reset_success_desc:
    "Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
  reset_password_desc: "Bitte geben Sie unten Ihr neues Passwort ein",
  password_required: "Bitte geben Sie Ihr Passwort ein",
  password_invalid:
    "Das Passwort muss mindestens 8 Zeichen lang sein und Buchstaben, Zahlen und Sonderzeichen enthalten",
  password_placeholder: "Geben Sie Ihr Passwort ein",
  confirm_password_required: "Bitte bestätigen Sie Ihr Passwort",
  passwords_do_not_match: "Die beiden eingegebenen Passwörter stimmen nicht überein",
  confirm_password_placeholder: "Passwort bestätigen",
  reset_password: "Neues Passwort festlegen",
  password_same_as_old: "Das neue Passwort darf nicht mit dem alten Passwort übereinstimmen",
  password_reset_failed: "Zurücksetzen des Passworts fehlgeschlagen",
};
